import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { AdminBrandDataSourceService } from '../../services/admin-brand-data-source.service';
import { AdminBrandDetailsForm } from '../../models/admin-brand-details-form';
import { AdminBrandDetailsFormComponent } from '../../components/admin-brand-details-form/admin-brand-details-form.component';
import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import { Observable } from 'rxjs';
import { SummernoteImageUpload } from '@web/shared/external';

@Component({
  selector: 'app-admin-brand-create',
  imports: [AdminBrandDetailsFormComponent, AlertsComponent],
  templateUrl: './admin-brand-create.component.html',
  styleUrl: './admin-brand-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminBrandCreateComponent {
  private readonly brandDataSource = inject(AdminBrandDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminBrandDetailsForm): void {
    this.brandDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => this.notifySubmitSuccessEvent(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  protected readonly uploadFn = (
    files: FileList,
  ): Observable<SummernoteImageUpload[]> => {
    return this.brandDataSource.uploadEditorImages(Array.from(files));
  };

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
